import { useMutation } from 'react-query';

import { getAPIErrorMessage } from '@nw/shared/utils';

import {
  GetPaymentProofExtractionResultRequestSchema,
  GetPaymentProofExtractionResultRequestType,
  GetPaymentProofExtractionResultResponseSchema,
  GetPaymentProofExtractionResultResponseType,
  normalizeGetPaymentProofExtractionResultResponse
} from '../../../services/NwExternalPaymentsServices/APIService/types';

import { useNwExternalPaymentsService } from '../useNwExternalPaymentsService';

interface UseGetPaymentProofExtractionResultApiInterface {
  getPaymentProofExtractionResultApi: (
    input: GetPaymentProofExtractionResultRequestType
  ) => Promise<GetPaymentProofExtractionResultResponseType>;
  isLoading: boolean;
  isError: boolean;
  error: string | null;
  status: 'idle' | 'loading' | 'success' | 'error';
  reset: () => void;
}

const useGetPaymentProofExtractionResultApi =
  (): UseGetPaymentProofExtractionResultApiInterface => {
    const { nwExternalPaymentsServiceInstance } = useNwExternalPaymentsService();

    const getPaymentProofExtractionResult = (
      requestObject: GetPaymentProofExtractionResultRequestType
    ) => {
      try {
        GetPaymentProofExtractionResultRequestSchema.parse(requestObject);
      } catch (error) {
        console.error('Invalid request object:', error);
        throw error;
      }

      return nwExternalPaymentsServiceInstance
        .getPaymentProofExtractionResult(requestObject)
        .then((response) => {
          const normalized = normalizeGetPaymentProofExtractionResultResponse(
            response
          );
          try {
            GetPaymentProofExtractionResultResponseSchema.parse(normalized);
          } catch (error) {
            console.error('Invalid response object:', error);
            throw error;
          }
          return normalized;
        });
    };

    const { mutateAsync, isLoading, isError, error, status, reset } = useMutation(
      getPaymentProofExtractionResult,
      {
        mutationKey: ['getPaymentProofExtractionResultApi']
      }
    );

    return {
      getPaymentProofExtractionResultApi: mutateAsync,
      isLoading,
      isError,
      error: error ? getAPIErrorMessage(error) : null,
      status,
      reset
    };
  };

export { useGetPaymentProofExtractionResultApi };
